<div *ngIf="show" class="fallback"><img src="/assets/svg/QS_New_Logo_Black.svg" alt="logo of quantum systems"></div>
